export default __webpack_public_path__ + "static/media/large_families.fea6d827.png";